/**
 * Client identity headers on every axios instance.
 *   X-Client-Platform: ios | android   (native wrapper)
 *   X-Client-Display:  standalone      (installed PWA)
 * The backend uses these to grant installed clients a longer session so
 * email / push deep links open straight into the page instead of sign-in.
 */
import axios from 'axios';

const isStandaloneDisplay = () => {
  try {
    return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) || window.navigator.standalone === true;
  } catch { return false; }
};

export const applyClientHeaders = () => {
  try {
    const plat = window.NativeApp?.isNative ? String(window.NativeApp.platform || '').toLowerCase() : '';
    if (plat) axios.defaults.headers.common['X-Client-Platform'] = plat;
    if (isStandaloneDisplay()) axios.defaults.headers.common['X-Client-Display'] = 'standalone';
  } catch { /* noop */ }
};

applyClientHeaders();
if (typeof window !== 'undefined') window.addEventListener('nativeapp-ready', applyClientHeaders, { once: true });
